import { navigateTo } from '../actions/navigateTo';

const handlerName = 'NavigateHome';

function handler(payload, store) {
  window.scrollTo(0, 0);

  navigateTo('/', store);
}

export { handlerName, handler };
